module.exports = __webpack_public_path__ + "img/br27.3dae93e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br27.jpg
// module id = k1O6
// module chunks = 0